import { createContext } from "react";

/**
 * True while the surrounding virtualized table is actively scrolling. Cells can read this to defer
 * expensive work (e.g. loading/decoding images) until the user stops, keeping the scroll smooth.
 * Defaults to false so cells render normally outside a virtualized table.
 */
export const TableScrollContext = createContext(false);
